export const bunkerTypes = [
  { label: 'HFO (inc VLSFO visc > 20)', value: 'hfo' },
  { label: 'LFO (inc VLSFO visc <= 20)', value: 'lfo' },
  { label: 'MGO', value: 'mgo' },
  { label: 'LNG', value: 'lng' },
  { label: 'PROPANE', value: 'propane' },
  { label: 'BUTANE', value: 'butane' },
  { label: 'METHANOL', value: 'methanol' },
  { label: 'ETHANE', value: 'ethane' },
];
export const bioBlendGradeTypes = [
  { label: 'HFO (inc VLSFO visc > 20)', value: 'hfo' },
  { label: 'LFO (inc VLSFO visc <= 20)', value: 'lfo' },
  { label: 'MGO', value: 'mgo' },
  { label: 'LNG', value: 'lng' },
  { label: 'PROPANE', value: 'propane' },
  { label: 'BUTANE', value: 'butane' },
  { label: 'METHANOL', value: 'methanol' },
  { label: 'ETHANE', value: 'ethane' },
  { label: 'FAME', value: 'fame_b' },
  { label: 'HVO', value: 'hvo_b' },
  { label: 'Bio-LNG', value: 'lng_b' },
  { label: 'Bio-Methanol', value: 'methanol_b' },
];

export const reportTypes = [
  {
    label: 'CAST OFF',
    value: 'cast_off',
  },
  {
    label: 'COSP',
    value: 'cosp',
  },
  {
    label: 'NOON',
    value: 'noon',
  },
  {
    label: 'EOSP',
    value: 'eosp',
  },
  {
    label: 'ALL FAST',
    value: 'all_fast',
  },
  {
    label: 'SPECIAL EVENT START',
    value: 'special_event_start',
  },
  {
    label: 'SPECIAL EVENT END',
    value: 'special_event_end',
  },
];

export const locationsForNoonForm = [
  {
    label: 'At sea',
    value: 'at_sea',
  },
  {
    label: 'In port/area/anchorage',
    value: 'in_port',
  },
  {
    label: 'At berth',
    value: 'at_berth',
  },
  {
    label: 'STS within port limits',
    value: 'sts_within_port_limits',
  },
  {
    label: 'STS outside port limits',
    value: 'sts_outside_port_limits',
  },
];
export const locationsForNoonFormAtBerth = [
  {
    label: 'Loading',
    value: 'loading',
  },
  {
    label: 'Discharging',
    value: 'discharging',
  },
  {
    label: 'Bunkering',
    value: 'bunkering',
  },
  {
    label: 'Repair',
    value: 'repair',
  },
  {
    label: 'DryDock',
    value: 'drydock',
  },
  {
    label: 'Other',
    value: 'other',
  },
];
export const locationsForCastOffForm = [
  {
    label: 'At berth',
    value: 'at_berth',
  },
  {
    label: 'STS within port limits',
    value: 'sts_within_port_limits',
  },
  {
    label: 'STS outside port limits',
    value: 'sts_outside_port_limits',
  },
];
export const locationsForAllFastForm = [
  {
    label: 'At berth',
    value: 'at_berth',
  },
  {
    label: 'STS within port limits',
    value: 'sts_within_port_limits',
  },
  {
    label: 'STS outside port limits',
    value: 'sts_outside_port_limits',
  },
];

export const shipConditions = [
  {
    label: 'Ballast',
    value: 'ballast',
  },
  {
    label: 'Laden',
    value: 'laden',
  },
];

export const portActivities = [
  {
    label: 'Loading',
    value: 'loading',
  },
  {
    label: 'Discharging',
    value: 'discharging',
  },
];

export const noonPortActivities = [
  {
    label: 'Anchored/Drifting/Manoeuvring',
    value: 'idle',
  },
  {
    label: 'Bunkering',
    value: 'bunkering',
  },
  {
    label: 'Canal Transit',
    value: 'canal_transit',
  },
  {
    label: 'Repair',
    value: 'repair',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const eospPortActivities = [
  {
    label: 'Anchored/Drifting/Manoeuvring',
    value: 'idle',
  },
  {
    label: 'Bunkering',
    value: 'bunkering',
  },
  {
    label: 'Canal Transit',
    value: 'canal_transit',
  },
  {
    label: 'Repair',
    value: 'repair',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const allFastPortActivities = [
  {
    label: 'Loading',
    value: 'loading',
  },
  {
    label: 'Discharging',
    value: 'discharging',
  },
  {
    label: 'Bunkering',
    value: 'bunkering',
  },
  {
    label: 'DryDock',
    value: 'drydock',
  },
  {
    label: 'Repair',
    value: 'repair',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const timezones = [
  {
    value: '-12:00',
    label: 'UTC-12:00',
  },
  {
    value: '-11:00',
    label: 'UTC-11:00',
  },
  {
    value: '-10:00',
    label: 'UTC-10:00',
  },
  {
    value: '-09:30',
    label: 'UTC-09:30',
  },
  {
    value: '-09:00',
    label: 'UTC-09:00',
  },
  {
    value: '-08:00',
    label: 'UTC-08:00',
  },
  {
    value: '-07:00',
    label: 'UTC-07:00',
  },
  {
    value: '-06:00',
    label: 'UTC-06:00',
  },
  {
    value: '-05:00',
    label: 'UTC-05:00',
  },
  {
    value: '-04:00',
    label: 'UTC-04:00',
  },
  {
    value: '-03:30',
    label: 'UTC-03:30',
  },
  {
    value: '-03:00',
    label: 'UTC-03:00',
  },
  {
    value: '-02:30',
    label: 'UTC-02:30',
  },
  {
    value: '-02:00',
    label: 'UTC-02:00',
  },
  {
    value: '-01:00',
    label: 'UTC-01:00',
  },
  {
    value: '+00:00',
    label: 'UTC±00:00',
  },
  {
    value: '+01:00',
    label: 'UTC+01:00',
  },
  {
    value: '+02:00',
    label: 'UTC+02:00',
  },
  {
    value: '+03:00',
    label: 'UTC+03:00',
  },
  {
    value: '+03:30',
    label: 'UTC+03:30',
  },
  {
    value: '+04:00',
    label: 'UTC+04:00',
  },
  {
    value: '+04:30',
    label: 'UTC+04:30',
  },
  {
    value: '+05:00',
    label: 'UTC+05:00',
  },
  {
    value: '+05:30',
    label: 'UTC+05:30',
  },
  {
    value: '+05:45',
    label: 'UTC+05:45',
  },
  {
    value: '+06:00',
    label: 'UTC+06:00',
  },
  {
    value: '+06:30',
    label: 'UTC+06:30',
  },
  {
    value: '+07:00',
    label: 'UTC+07:00',
  },
  {
    value: '+08:00',
    label: 'UTC+08:00',
  },
  {
    value: '+08:45',
    label: 'UTC+08:45',
  },
  {
    value: '+09:00',
    label: 'UTC+09:00',
  },
  {
    value: '+09:30',
    label: 'UTC+09:30',
  },
  {
    value: '+10:00',
    label: 'UTC+10:00',
  },
  {
    value: '+10:30',
    label: 'UTC+10:30',
  },
  {
    value: '+11:00',
    label: 'UTC+11:00',
  },
  {
    value: '+12:00',
    label: 'UTC+12:00',
  },
  {
    value: '+12:45',
    label: 'UTC+12:45',
  },
  {
    value: '+13:00',
    label: 'UTC+13:00',
  },
  {
    value: '+14:00',
    label: 'UTC+14:00',
  },
];

export const reportDescriptions = {
  noon: 'Noon reports are to be submitted daily at noon local time, whether in port or at sea',
  cosp: 'COSP reports are to be submitted at departure from port and to include Cargo quantity in board',
  eosp: 'EOSP reports are to be submitted at arrival to port',
};

export const operationModes = [
  {
    value: 'ice',
    label: 'Ice',
  },
  {
    value: 'emergency',
    label: 'Emergency',
  },
];

export const ciiShipTypes = [
  { label: 'Tanker (oil, prod, chem, etc)', value: 'tanker' },
  { label: 'Gas carrier/LNG carrier', value: 'liquefied_gas_tanker' },
  { label: 'Container ship', value: 'container' },
  { label: 'RORO vehicle carrier', value: 'car_carrier' },
  { label: 'Other (dry bulk, general cargo)', value: 'default' },
];
export const ciiDischargePumpTypes = [
  { label: 'Steam driven', value: 'steam', hint: 'Report cargo discharge consumption in MT' },
  { label: 'Electrical', value: 'electric', hint: 'Report cargo discharge consumption in kWh and SFOC from generator' },
  { label: 'Standalone engine \n(including diesel power pack)', value: 'standalone', hint: 'Other, report cargo discharge consumption in MT' },
];

export const mainEngineTypes = [
  { label: 'LNG Otto (dual fuel medium speed)', value: 'lng_otto_df_medium_speed' },
  { label: 'LNG Otto (dual fuel slow speed)', value: 'lng_otto_df_lp_slow_speed' },
  { label: 'LNG Diesel (dual fuel slow speed)', value: 'lng_diesel_df_hp_slow_speed' },
  { label: 'LBSI (lean burn spark ignited)', value: 'lng_lbsi_lp' },
  { label: 'Gas Turbine / Steam Turbine', value: 'lng_turbine_boiler' },
];
